var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-page"},[(_vm.loaded)?_c('HubParagraphs',{attrs:{"name":"paragraphs"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }